<div class="dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <h2>Conversation Explorer</h2>
      <button mat-stroked-button color="accent" (click)="downloadCSV()">
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>
  </div>

    <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="sp" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="sp"></mat-datepicker-toggle>
      <mat-datepicker #sp></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="ep" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="ep"></mat-datepicker-toggle>
      <mat-datepicker #ep></mat-datepicker>
    </mat-form-field>

    <!-- <button mat-raised-button color="primary" (click)="fetchCrossTab()">
      Update View
    </button> -->
     <div class="filter-actions" style="display: flex; gap: 8px;">
      <button mat-raised-button color="primary" (click)="loadData()">
        Update
      </button>
      <button mat-stroked-button color="accent" (click)="downloadCSV()" >
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>
  </div>

  <div class="explorer-actions" style="display: flex; gap: 1rem; align-items: center; margin-bottom: 1rem;">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Search ID or Category</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. conv_123" #input>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    </div>

  <div class="mat-elevation-z8 table-container">
    <table mat-table [dataSource]="dataSource" matSort class="styled-table">

      <ng-container matColumnDef="conversation_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Conversation ID </th>
        <td mat-cell *matCellDef="let row"> <code>{{row.conversation_id}}</code> </td>
      </ng-container>

      <ng-container matColumnDef="categories">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Categories </th>
        <td mat-cell *matCellDef="let row">
          <mat-chip-set>
            <mat-chip [matTooltip]="row.category_list.join(', ')">
              {{row.unique_categories}} Types
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="outcomes">
        <th mat-header-cell *matHeaderCellDef> Outcome Counts </th>
        <td mat-cell *matCellDef="let row">
          <span style="color: #10b981; font-weight: 600;">{{row.satisfied_count}} S</span> / 
          <span style="color: #ef4444; font-weight: 600;">{{row.not_satisfied_count}} NS</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Interactions </th>
        <td mat-cell *matCellDef="let row"> {{row.total_interactions}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="primary" (click)="viewTranscript(row.conversation_id)" matTooltip="View Details">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">No data matching the filter "{{input.value}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page"></mat-paginator>
  </div>
</div>